import FilterChip from '@/components/Filter/FilterChip';
import { ChipProps } from '@mui/material';
import { SxProps, Theme } from '@mui/system';

interface IProps extends ChipProps {
  sx?: SxProps<Theme>;
  onRemove?: () => void;
}

const SelectionChip = ({ sx, ...props }: IProps) => {
  return (
    <FilterChip
      {...props}
      variant='contained'
      sx={{
        '& .type-label': {
          color: '#84818A',
        },
        '& .chip-label': {
          color: 'black',
        },
        height: '30px',
        background: '#1B433226',
        ...sx,
      }}
    />
  );
};

export default SelectionChip;
